function RelatedArticlesEllipsoidConversions() {
  return (
    <div
      id="ts-relatedarticles-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-relatedarticles-content"
        className="w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Ellipsoid Conversions in TerraStation
        </div>

        <div className="w-full bg-gray-50 text-light-text p-6 mt-6 rounded-lg shadow-sm space-y-4">
          <p>
            TerraStation provides the capability of converting map data from one ellipsoid
            to another. The conversion involves a mathematical transform using relative
            offsets for the origin of the different ellipsoids used to represent the
            earth's surface.
          </p>
          <p>
            To refresh your memory, the projection on a map is the mathematical technique
            used to transform a spherical object into a flat surface. Various projections
            emphasize certain traits, such as equal area, true directions, etc.
          </p>
          <p>
            Because the earth is not exactly spherical, but rather is "squashed"
            ("flattened"), various studies have been made to determine the "best"
            representation of the earth. These differ slightly in the origin or
            (0,0,0) coordinate location, and also as to the amount of flattening ascribed
            to the earth's surface.
          </p>
          <p>
            Ellipsoid conversions are becoming much more important as new well surface
            location data is obtained using satellite Global Position System technology.
            Most of these devices base their calculations on the GRS 80 ellipsoid
            definition (which is used in the NAD 83 datum).
          </p>
          <p>
            The latitude/longitude location for a given spot on the earth may differ
            between GRS 80 and the Clarke, 1866 (commonly used in the U.S.) by what would
            amount to a surface relocation of 100 meters or more in some places.
          </p>
          <p>
            The sea-level elevation of a given point may also be repositioned slightly
            with an ellipsoid conversion. TerraStation allows you to convert structural
            elevations as part of the conversion process.
          </p>
          <p>
            This functionality is accessed via the Input/Output - Map Import sequence,
            because normally one would not wish to convert an entire project between
            ellipsoids. By selecting the appropriate ellipsoid for incoming data,
            however, data from dissimilar ellipsoids can be combined in TerraStation.
          </p>
          <p>
            For advanced users, TerraStation can compute the relative ellipsoid offset
            between two ellipsoids when latitude/longitude locations are known for a
            given point in two different ellipsoids.
          </p>
          <p>
            We hope you find this capability useful and welcome any comments or suggestions
            regarding its improvement.
          </p>
        </div>
      </div>
    </div>
  );
}

export default RelatedArticlesEllipsoidConversions;
